import { ValidatorFn } from '@angular/forms';
import { ExtendedFormControl } from '../extended-form-control.class';

export class DateControl extends ExtendedFormControl {
    readonly inputType = 'text';

    constructor(name: string, value: Date, validations: ValidatorFn[] = [], disabled = false) {
        super(name, value, validations, disabled);
    }
}
